export default function StickersIcon({ className = "", onClick = null }) {
  return (
    <svg
      id="Capa_1"
      data-name="Capa 1"
      className={`stickers-icon ${className}`}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width="22"
      height="22"
      fill="var(--app-theme-color)"
      color="var(--app-theme-color)"
    >
      <path d="M413.32,234.59c.36-5.75-.24-11.99-1.8-18.7-5.27-33.48-21.27-63.6-46.35-86.53-30.19-27.6-71.09-42.8-115.17-42.8-90.12,0-163.44,73.32-163.44,163.44,0,44.08,15.2,84.98,42.8,115.17,28.46,31.13,67.98,48.28,111.27,48.28,90.45,0,172.82-82.37,172.82-172.82,0-2.02-.05-4.03-.12-6.04ZM147.81,348.3c-23.37-25.57-36.25-60.48-36.25-98.3,0-76.34,62.1-138.44,138.44-138.44,37.82,0,72.73,12.87,98.3,36.25,20.92,19.13,34.24,44.33,38.58,72.4h-.03c.04.15.07.28.1.42.67,4.44,1.12,8.96,1.33,13.53-.3,2.57-1,4.78-2.12,6.59-5.68,9.16-24.08,13.05-41.87,16.82-21.1,4.47-45.02,9.53-59.9,25.37-11.87,12.64-16.61,26.94-19.93,40.3-64.51,11.79-89.67-42.95-90.74-45.37-2.77-6.3-10.11-9.19-16.43-6.44-6.33,2.75-9.24,10.11-6.49,16.44.35.82,8.91,20.2,28.33,37.02,14.18,12.28,36.39,25.06,67.45,25.06,3.56,0,7.24-.18,11.04-.53-5.1,14.31-14.13,26.96-37.43,37.47-28.07-4.34-53.27-17.66-72.39-38.58ZM343.21,343.21c-22.49,22.49-50.27,37.48-78.75,42.94,14.83-16.18,18.98-34.16,22.57-49.72,3.25-14.07,6.05-26.22,15.58-36.36,9.51-10.12,28.5-14.14,46.86-18.03,12.06-2.55,24.33-5.16,34.91-9.7-6.54,25.69-20.76,50.47-41.17,70.88Z" />
      <circle cx="199.74" cy="205.22" r="19.65" transform="translate(-30.29 34.64) rotate(-9.22)" />
      <circle cx="303" cy="205.22" r="19.65" />
    </svg>
  );
}
